/**
 * Update date: 23-05-2023
 * Screen 2017.4
 */
import React, { useState, useRef, useEffect } from 'react';
import 'jspdf-autotable';
import useAxios from 'axios-hooks';
import TextBoxes from './HUBTextArea';
import FormSearch from './FormSearch';
import useFormatTime from 'hooks/useFormatTime';
import LoadPanel from 'app/components/LoadPanel';
import { DataGridFull } from 'app/components/DataGrid';
import useDictionary from 'hooks/useDictionary';
import './styles.scss';
import { useApp } from 'app';
import { dateTimeRequestFormat } from 'utils/format';
/**
 * create context
 */
export const MallContext = React.createContext({
  mallData: [],
});

export default function HUBSendHistory() {
  const defaultParam = {
    channelSec: 'HUB',
    mallCode: '',
    date: new Date(),
    target: 'stock,order,goods,ctorder,receive,takeout,forward,return,center',
    keyword: '',
  };
  const { themePro }: any = useApp();
  const [param, setParam] = useState(defaultParam);
  const [selectedRow, setSelectedRow] = useState<any>();
  const [mallData, setMallData] = useState<any>([]);
  const [showModalView, setShowModalView] = useState<boolean>(false);
  const { DateTimeFormat } = useFormatTime();
  const dataGridRef: any = useRef(null);
  const { t }: any = useDictionary({
    programId: '2017.4',
  });
  const [{ data: dataMall, loading: loadingDataMall }] = useAxios({
    url: '/ecommerce/mall-info',
    method: 'POST',
    data: {},
  });
  /**
   * fetch data
   */
  useEffect(() => {
    if (dataMall && !loadingDataMall) {
      setMallData(dataMall?.data);
    }
  }, [dataMall, loadingDataMall]);

  const [{ data: dataMallInfo, loading: loadingMallInfo }, refetchData] =
    useAxios(
      {
        url: '/ecommerce/mall-api-log',
        method: 'POST',
        data: {
          ...param,
          channelSec: param.channelSec,
          // mallCode: param.mallCode,
          mallCode: 'HUB',
          date: dateTimeRequestFormat(param.date),
          target: param.target
            ? param.target.split(',').map(item => item.trim())
            : [],
          keyword: param.keyword,
        },
      },
      {
        manual: true,
      },
    );

  const [
    { data: dataMallInfoDetail, loading: loadingMallInfoDetail },
    refetchDataDetail,
  ] = useAxios(
    {
      url: '/ecommerce/mall-api-log',
      method: 'GET',
    },
    {
      manual: true,
    },
  );
  /**
   * render view
   *
   * @param {*} record
   * @return {*}
   */
  const renderView = (record: any) => {
    return (
      <div
        className="cell-link"
        onClick={() => {
          setShowModalView(true);
          refetchDataDetail({
            url: `/ecommerce/mall-api-log/${record?.data?.id}`,
          });
        }}
      >
        {t('View')}
      </div>
    );
  };

  const columns: any = [
    {
      dataField: 'apiType',
      caption: t('Target'),
      alignment: themePro ? 'left' : 'center',
      allowEditing: false,
    },
    {
      dataField: 'logId',
      caption: t('Log ID'),
      alignment: themePro ? 'left' : 'center',
      allowEditing: false,
    },
    {
      dataField: 'apiUrl',
      caption: t('Api URL'),
      alignment: 'left',
      allowEditing: false,
    },
    {
      dataField: 'startDate',
      caption: t('Start Datetime'),
      alignment: themePro ? 'left' : 'center',
      dataType: 'date',
      format: DateTimeFormat,
      allowEditing: false,
    },
    {
      dataField: 'endDate',
      caption: t('End Datetime'),
      alignment: themePro ? 'left' : 'center',
      dataType: 'date',
      format: DateTimeFormat,
      allowEditing: false,
    },
    {
      dataField: '',
      caption: t('Action'),
      alignment: themePro ? 'left' : 'center',
      cellRender: renderView,
    },
  ];
  /**
   * fetch data
   */
  useEffect(() => {
    if (dataMallInfoDetail?.data) {
      setSelectedRow(dataMallInfoDetail?.data);
    }
  }, [dataMallInfoDetail]);

  const value: any = {
    mallData,
    refetchData,
  };

  const loadingAll = loadingMallInfo || loadingMallInfoDetail;
  /**
   * render content
   */
  return (
    <MallContext.Provider value={value}>
      <>
        <LoadPanel visible={loadingAll} />
        <div className="hub-send-history">
          <div className="main">
            <FormSearch
              param={param}
              setParam={setParam}
              refetchData={refetchData}
            />
          </div>
          <div className="main">
            <DataGridFull
              ref={dataGridRef}
              dataSource={dataMallInfo?.data}
              columns={columns}
              options={{
                onToolbarPreparing: (e: any) => {
                  e.toolbarOptions.items.unshift({
                    location: 'before',
                    template: 'totalCount',
                  });
                },
                selection: {
                  mode: 'single',
                  showCheckBoxesMode: 'onClick',
                },
                columnAutoWidth: true,
              }}
            />
          </div>
          <div className="main">
            <TextBoxes
              visible={showModalView}
              onHiding={() => {
                setShowModalView(!showModalView);
              }}
              param={param}
              selectedRow={selectedRow}
            />
          </div>
        </div>
      </>
    </MallContext.Provider>
  );
}
